import { contentTypeOf } from "../../messages/utils/attachmentRules";

/** Mirrors Materials/Model/MaterialUploadRules.cs: the caps of the instructor's library upload. */
const MB = 1024 * 1024;
export const FILE_MAX_BYTES = 25 * MB;
export const VIDEO_MAX_BYTES = 100 * MB;

const VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime"];
/** Photos the browser resizes and re-encodes before upload (a GIF goes as it is). */
const RESIZED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"];

/** The content type the upload declares: the browser's, or the extension's when it gave none. */
export const materialContentTypeOf = (file: File): string => contentTypeOf(file);

export const isVideoType = (contentType: string): boolean => VIDEO_TYPES.includes(contentType);

/** True for photos that are resized first, so their picked size is not what is uploaded. */
export const isResizedImageType = (contentType: string): boolean => RESIZED_IMAGE_TYPES.includes(contentType);

export const maxBytesFor = (contentType: string): number =>
  isVideoType(contentType) ? VIDEO_MAX_BYTES : FILE_MAX_BYTES;

/** Above the cap before a byte is sent; a photo is judged after its resize. */
export const isTooLarge = (file: File): boolean => {
  const contentType = materialContentTypeOf(file);
  return !isResizedImageType(contentType) && file.size > maxBytesFor(contentType);
};

/** Files larger than the plain-file cap get the Wi-Fi hint. */
export const isLargeUpload = (file: File): boolean => file.size > FILE_MAX_BYTES;
